/**
 * Marka iletişim sabitleri.
 *
 * Numara kurumsal sitedekinin aynısı (`site/content/site.mjs`): iki yüzde farklı
 * numara görünmesin diye tek yerden okunur. Değişirse ikisi birlikte güncellenir.
 */
export const WHATSAPP_URL = 'https://wa.me/+905556500742';
